// Turbolinks keeps the users's scroll position even on pages that it shouldn't
// This may be due to changes in <head> or other issues listed in the issue below:
// https://github.com/turbolinks/turbolinks/issues/181#issuecomment-426869211

const applyTurbolinksScrollPatch = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
};

export default applyTurbolinksScrollPatch;
